export const initFancy = function() {
  Fancybox.bind('[data-fancybox]', {
    dragToClose: false
  });

  const fancyLink = document.querySelectorAll('[data-fancybox]');

  if (fancyLink.length > 0) {
    fancyLink.forEach((item) => {
      item.addEventListener('click', (i) => {
        const fancyContainer = document.querySelector('.fancybox__container');
        if (fancyContainer) {
          Fancybox.close();
        }

      })
    })
  }
}
